import api from './api';
import cache from './cache'

export function getPic(picUrl) {
  return `https://${api.public.config.bucket}.${api.public.config.endPoint}/${url}`;
}

export function getImgUrl(url) {
  // console.log(url)
  let cacheUrl= cache.fetchOssPath() || 'https://img.91cdkey.com/';
  return cacheUrl + url;
}

export function getImgUrls(url) {
  // console.log(url)
  let urls =[cache.fetchOssPath() + url];
  return urls;
}

export function priceFilter(price) {
  if (price) {
    return (price / 10000).toFixed(2);
  }
  return "0.00";
}

/**
 * 获取年月日时分
 * @param time
 * @returns {string}
 */
export function formatTime(time, type) {
  if (parseInt(time) === 0) {
    return '--'
  }
  let date = new Date(time * 1000);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  if (type === 1) {
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  }
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second;
}

/**
 * 获取年月日时分
 * @param time
 * @returns {string}
 */
export function formatDay(time) {
  if (time == '0') {
    return '--'
  }
  let date = new Date(time * 1000);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  return y + '年' + m + '月' + d + '日 ';
}

export function getLocationName(type) {
  switch (type) {
    case "9i_recommen":
      return "9i推荐";
      break;
    case "9i_desktop":
      return "9i桌标";
      break;
    case "9i_current_news":
      return "时事新闻";
      break;
    case "9i_desktop_pop":
      return "弹窗";
      break;
    case "9i_search":
      return "搜索条";
      break;
    case "9i_other":
      return "其他";
      break
  }
}

// 列表序号
export function getListIndex(val, listParam) {
  return val + 1 + (listParam.page - 1) * listParam.limit
}

/**
 * 获取年月日时分
 * @param time
 * @returns {string}
 */
export function valueIsBankReturn(value) {
  if (value == '' || value == undefined || value == null) {
    return '--'
  }
  return value;
}

export function getPayType(payType) {
  switch (payType) {
    case 1:
      return '支付宝'
    case 2:
      return '微信'
    case 3:
      return '威富通-支付宝'
    case 4:
      return '威富通-微信'
    case 5:
      return '汇付-支付宝'
    case 6:
      return '汇付-微信'
    default:
      return '未知'
  }
}

export function getS9891CardDetails(details,index) {
  if (details) {
    let cards = details.split(";");
    let length = cards.length;
    if (length - 1 >= index) {
      let card = cards[index];
      let split = card.split("：");
      return split[1];
    }
    return "";
  }
  return "";
}


  export function show9891PromoAmount(price) {
    if (price) {
      return "￥" +price;
    }
    return "￥0.00";
  }

export function showDeleteStatus(isDelete) {
  switch (isDelete) {
    case 0:
      return '正常'
    case 1:
      return '已删除'
    default:
      return '未知'
  }
}



// WEBPACK FOOTER //
// ./src/utility/filter.js